import React from 'react'
import { Select, Row, Col, Form } from 'antd'
import MongoDBRouteExecuteQry from './routes/mongodb-execute-qry'
import MemoryStore from '../../../../../utils/memory-store'

class MongoDBRouteMain extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      routeType: props.entry.routeData.routeType ? props.entry.routeData.routeType : '0'
    }
  }

  componentDidMount () {
    this.onFieldChange('routeType', '0')
  }

  onChangeRouteType (e) {
    this.entry.custom.isModifiedSubform = true
    this.setState({ routeType: e })
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value
  }

  render () {
    return (
      <Row>
        <Col span={24}>
          <h3>Route Info</h3>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>Route Type
            <Select
              className='route_type'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.routeType}
              onChange={e => {
                this.onChangeRouteType(e)
                this.onFieldChange('routeType', e)
              }}
            >
              <Select.Option value=''>-Select-</Select.Option>
              <Select.Option value='0'>Execute Query</Select.Option>
            </Select>
          </Form.Item>
          {this.state.routeType === '0' ? (
            <MongoDBRouteExecuteQry tabKey={this.props.tabKey} entry={this.props.entry} />
          ) : null}
        </Col>
      </Row>
    )
  }
}

export default MongoDBRouteMain
